import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';
import App from '@Pages/App';
import Profile from '@Pages/Profile';
import GPTPage from '@Pages/GPTPage';
import Analyzer from '@Pages/analyzer/Analyzer';
import Login from '@Pages/auth/login';
import ErrorPage from '@Pages/ErrorPage';
import PrivateRoutes from '@Utils/PrivateRoutes';
import { ChatHistoryProvider } from '@Context/ChatHistoryContext';
import Prompts from '@Pages/Prompts';
import { UtilityContextProvider } from '@Context/prompt-toolbox/UtilityContext';
import { PromptToolboxContextProvider } from '@Context/prompt-toolbox/PromptToolboxContext';
import { DiffMergeProvider } from '@Context/prompt-toolbox/DiffMergeContext';
import { ProfileContextProvider } from '@Context/ProfileContext';
import { AnalyzerContextProvider } from '@Context/AnalyzerContext';
import AuthCallback from '@Pages/auth/AuthCallback';
import AnalyzerReportsPage from '@Pages/AnalyzerReportsPage';
import ArtilleryReportsPage from '@Pages/ArtilleryReportsPage';
export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route element={<PrivateRoutes />}>
        <Route path="/home" element={<App />} ErrorBoundary={ErrorPage} />
        <Route
          path="/profile"
          element={
            <UtilityContextProvider>
              <ProfileContextProvider>
                <Profile />
              </ProfileContextProvider>
            </UtilityContextProvider>
          }
          ErrorBoundary={ErrorPage}
        />
        <Route
          path="/gpt"
          ErrorBoundary={ErrorPage}
          element={
            <UtilityContextProvider>
              <ChatHistoryProvider>
                <GPTPage />
              </ChatHistoryProvider>
            </UtilityContextProvider>
          }
        />
        <Route
          path="/prompts"
          element={
            <UtilityContextProvider>
              <PromptToolboxContextProvider>
                <DiffMergeProvider>
                  <Prompts />
                </DiffMergeProvider>
              </PromptToolboxContextProvider>
            </UtilityContextProvider>
          }
          ErrorBoundary={ErrorPage}
        />
        <Route
          path="/analyzer"
          element={
            <UtilityContextProvider>
              <AnalyzerContextProvider>
                <Analyzer />
              </AnalyzerContextProvider>
            </UtilityContextProvider>
          }
          ErrorBoundary={ErrorPage}
        />
        <Route
          path="/analyzer-reports"
          element={
            <UtilityContextProvider>
              <AnalyzerReportsPage />
            </UtilityContextProvider>
          }
          ErrorBoundary={ErrorPage}
        />
        <Route path="*" element={<ErrorPage />} />
        <Route
          path="/artillery-reports"
          element={
            <UtilityContextProvider>
              <ArtilleryReportsPage />
            </UtilityContextProvider>
          }
          ErrorBoundary={ErrorPage}
        />
        <Route path="*" element={<ErrorPage />} />
      </Route>
    </>
  )
);
